module.exports = __webpack_public_path__ + "static/media/granizo.95b5cc97.svg";